import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SolicitudForm from '../components/SolicitudForm';
import ConsultaEstatus from '../components/ConsultaEstatus';

// Asume que tu logo se llama 'logo.png' y está en la carpeta 'public'
const logoUrl = '/logo azul-09.png';

function PublicPage() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // BUSQUEDA EXHAUSTIVA DEL TOKEN
    // Buscamos en localStorage y sessionStorage con los nombres más comunes
    const token = localStorage.getItem('authToken') || 
                  localStorage.getItem('token') || 
                  localStorage.getItem('access_token') ||
                  sessionStorage.getItem('access') ||
                  sessionStorage.getItem('token');
                  
    setIsLoggedIn(!!token); // Si encontró algo, marca como logueado
  }, []);

  return (
    <Container maxWidth="md" sx={{ position: 'relative', py: 4 }}>
      
      {/* --- BOTÓN DE RETORNO (SOLO SI ESTÁ LOGUEADO) --- */}
      {isLoggedIn && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button 
            variant="contained"  // Lo cambié a 'contained' para que se vea más
            color="secondary"    // Color secundario para resaltar
            onClick={() => navigate('/dashboard')}
            sx={{ fontWeight: 'bold' }}
          >
            &larr; Volver al Dashboard
          </Button>
        </Box>
      )}

      {/* --- ENCABEZADO --- */}
      <Box sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src={logoUrl} alt="Logo Contraloría" style={{ height: '90px', marginBottom: '20px' }} />
        
        {/* CORRECCIÓN DE COLOR: Ahora usa 'text.primary' (Gris oscuro estándar) */}
        <Typography 
          variant="h4" 
          component="h1" 
          align="center" 
          gutterBottom 
          sx={{ fontWeight: 'bold', color: 'text.primary' }} 
        >
          OFICINA DE ATENCIÓN AL CIUDADANO
        </Typography>
        
        <Typography variant="subtitle1" align="center" color="text.secondary">
          Sistema Integrado de Participación Ciudadana - SIPC
        </Typography>
      </Box>

      <SolicitudForm />
      
      <Box sx={{ mt: 6 }}>
        <ConsultaEstatus />
      </Box>

    </Container>
  );
}

export default PublicPage;
